import { createContext as i, useContext as o } from "react";
const t = i({
  setTypifying: () => {
  },
  typify: () => {
  },
  typifying: !1
}), y = t.Provider, n = () => o(t);
export {
  t as TypifycationContext,
  y as TypifyingProvider,
  n as useTypifycation
};
//# sourceMappingURL=TypificationContext.js.map
